import { DesktopWindowsOutlinedIcon, DescriptionOutlinedIcon } from '@shared/components';

export type ExamTypeVariant = 'COMPUTER' | 'PAPER';

const VARIANT_ICON_MAP = {
  COMPUTER: DesktopWindowsOutlinedIcon,
  PAPER: DescriptionOutlinedIcon,
};

interface ExamTypeIconProps {
  variant: ExamTypeVariant;
}

export default function ExamTypeIcon(props: Readonly<ExamTypeIconProps>) {
  const { variant } = props;

  const IconComponent = VARIANT_ICON_MAP[variant];

  return <IconComponent sx={{ fontSize: '24px' }} />;
}
